exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2wEPNkcZQiSOPhkaZSbca2 .dnn-persona-bar-page-body .persona-bar-page-body {\n  background: transparent;\n  border: none;\n}\n._2wEPNkcZQiSOPhkaZSbca2 .load-more-button {\n  text-align: center;\n}\n", ""]);

// Exports
exports.locals = {
	"sitesPortalList": "_2wEPNkcZQiSOPhkaZSbca2"
};